import { getPath } from '@/router/common'

const baseUrl = {
  title: '优惠券设置',
  path: 'WeixinCoupon'
}

export default [
  {
    path: getPath('WeixinCouponSetList', baseUrl),
    name: 'WeixinCouponSetList',
    component: () =>
      import(
        /* webpackChunkName: "WeixinCouponSetList" */ '@/views/weixinCoupon/weixinCouponSetList/index.vue'
      ),
    meta: {
      title: '优惠券设置'
    }
  },
  {
    path: getPath('WeixinCouponList', baseUrl),
    name: 'WeixinCouponList',
    component: () => import(/* webpackChunkName: "WeixinCouponList" */ '@/views/weixinCoupon/weixinCouponList/index.vue'),
    meta: {
      title: '优惠券列表'
    }
  }
]
